















import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import RadioToggleButton from '../buttons/RadioToggleButton.vue';

interface Option {
    value: string;
    label: string;
}

export default Vue.extend({
    components: { RadioToggleButton },
    props: {
        value: {
            type: Object as () => Option,
            required: true,
        },
        options: {
            type: Array as () => Option[],
            required: true,
        },
    },
    data: function() {
        return {
            picked: this.value || this.options[0],
            name: uuidv4(),
        };
    },
    watch: {
        picked() {
            this.$emit('input', this.picked);
        },
    },
});
